gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin);


//////////////// FUNCIONES HEADER START //////////
document.addEventListener('DOMContentLoaded', function () {
    const collapseH = document.getElementById('collapseHeader');
    const btnMenu = document.querySelector('.btn-menu-mov');
    const backdrop = document.querySelector('.header .backdrop');
    if (!collapseH) return;

    collapseH.addEventListener('show.bs.collapse', () => document.body.classList.add('open-menu'));
    collapseH.addEventListener('hidden.bs.collapse', () => document.body.classList.remove('open-menu'));

    backdrop.addEventListener('click', () => bootstrap.Collapse.getOrCreateInstance(collapseH).hide());

    // Al pasar de 1130px se cierra el menú y se resetea el botón
    window.matchMedia('(min-width: 1130px)').addEventListener('change', (e) => {
        if (e.matches) {
            collapseH.classList.remove('show');
            btnMenu.classList.add('collapsed');
            btnMenu.setAttribute('aria-expanded', 'false');
            document.body.classList.remove('open-menu');
        }
    });
    if (document.querySelector(".c-list-nav a")) {
        scrollStickyCard();
        // Recalcula los triggers con la posición de scroll actual (sin forzar subir arriba)
        ScrollTrigger.refresh();
    }
});
//////////////// FUNCIONES HEADER END //////////

//////////////// FUNCIONES STEPS START //////////
document.addEventListener('DOMContentLoaded', function () {
    const steps = document.querySelector('.js-how-works');
    if (!steps) return;

    const items = Array.from(steps.querySelectorAll('.c-steps_item'));
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const mobileCircleFillDurationMs = 500;
    const desktopCircleFillDurationMs = 600;
    const desktopMinWidth = 1024;
    let targetIndex = -1;
    let activeIndex = -1;
    let lastActivationAt = -Infinity;
    let animationTimer = null;

    const getCircleFillDurationMs = () => (
        window.innerWidth >= desktopMinWidth ? desktopCircleFillDurationMs : mobileCircleFillDurationMs
    );

    const clearAnimationTimer = () => {
        window.clearTimeout(animationTimer);
        animationTimer = null;
    };

    // Activa los pasos en orden hasta targetIndex, esperando a que termine de rellenarse el círculo anterior
    const scheduleNext = () => {
        if (animationTimer || activeIndex >= targetIndex) return;

        const wait = Math.max(0, lastActivationAt + getCircleFillDurationMs() - performance.now());

        animationTimer = window.setTimeout(() => {
            animationTimer = null;
            activeIndex++;
            items[activeIndex].classList.add('active');
            lastActivationAt = performance.now();
            scheduleNext();
        }, wait);
    };

    // Cada paso arranca cuando su parte superior sube del 70% de la pantalla (50% en móvil)
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (!entry.isIntersecting) return;

            observer.unobserve(entry.target);
            targetIndex = Math.max(targetIndex, items.indexOf(entry.target));

            if (prefersReducedMotion) {
                items.slice(0, targetIndex + 1).forEach(item => item.classList.add('active'));
                activeIndex = targetIndex;
                return;
            }

            scheduleNext();
        });
    }, {
        rootMargin: window.innerWidth >= desktopMinWidth ? '0px 0px -30% 0px' : '0px 0px -20% 0px',
        threshold: 0,
    });

    items.forEach(item => observer.observe(item));

    window.addEventListener('beforeunload', clearAnimationTimer);
});
//////////////// FUNCIONES STEPS END //////////

/* ==========================================================================
   ESTE ES EL CODIGO PARA EL COUNTER
   Anima los numeros de .js-counter con efecto rodillo al entrar en pantalla.
   Uso: <p class="js-counter">+50</p>  (estilos en _c-counter.scss)
   ========================================================================== */
document.addEventListener('DOMContentLoaded', function () {
	var counters = document.querySelectorAll('.js-counter');
	if (!counters.length) return;

	var strip = '0123456789'.split('').join('<br>');
	strip = strip + '<br>' + strip;

	function animateCounter(el) {
		el.querySelectorAll('.c-counter_strip').forEach(function (s) {
			var n = parseInt(s.getAttribute('data-value'), 10) + 10; // todos dan al menos una vuelta completa
			s.style.transitionDelay = (Math.random() * .8) + 's';
			s.style.transform = 'translateY(-' + (n * 5) + '%)';
		});
	}

	counters.forEach(function (el) {
		var text = el.textContent.trim();
		var firstDigit = text.match(/\d/);
		var wrapper = el.closest('.c-counter');
		if (wrapper && firstDigit && firstDigit[0] === '1') wrapper.classList.add('m-left');
		var html = text.split('').map(function (ch) {
			return /\d/.test(ch)
				? '<span class="c-counter_digit"><span class="c-counter_strip" data-value="' + ch + '">' + strip + '</span></span>'
				: '<span class="c-counter_char">' + ch + '</span>';
		}).join('');
		el.innerHTML = '<span class="visually-hidden">' + text + '</span><span class="c-counter_digits" aria-hidden="true">' + html + '</span>';
	});

	var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
	if (reduceMotion || !('IntersectionObserver' in window)) {
		counters.forEach(animateCounter);
		return;
	}

	var observer = new IntersectionObserver(function (entries) {
		entries.forEach(function (entry) {
			if (!entry.isIntersecting) return;
			animateCounter(entry.target);
			observer.unobserve(entry.target);
		});
	}, { threshold: 1 });

	counters.forEach(function (el) { observer.observe(el); });
});


//////////////// STICKY CARD ANIMACION SCROLL START /////////////////////////
function scrollStickyCard() {
        const anchors = document.querySelectorAll(".c-list-nav a");
        
        
        anchors.forEach((anchor, index) => {
            const targetId = anchor.getAttribute('href');  
            const targetSection = document.querySelector(targetId);  
            const nextTargetSection = anchors[index + 1] ? document.querySelector(anchors[index + 1].getAttribute('href')) : null;
            const circle = anchor.querySelector('#circle');  
            const chevron = anchor.querySelector('.chevron');  
            if (circle && targetSection) {
                gsap.set(circle, {
                  drawSVG: '0%',   
                });
                const scrollTriggerConfig = nextTargetSection
                    ? {
                        trigger: targetSection,
                        start: "top 70%",
                        endTrigger: nextTargetSection,
                        end: "top 60%", 
                        scrub: true,
                        // markers: true
                        }
                    : {
                        trigger: targetSection,
                        start: "clamp(top 60%)",
                        end: "max", // Termina al final de la página aunque la sección sea corta
                        scrub: true,
                        // markers: true
                        };
            
            
                gsap.to(circle, {
                  drawSVG:'0% 100%',  
                  scrollTrigger: scrollTriggerConfig,
                  ease: Power1.easeInOut 
                });
                gsap.to(chevron, {
                 color: '#fff',
                 scrollTrigger: scrollTriggerConfig,
                  ease: Power1.easeInOut 
                });
              }
          });
}
//////////////// STICKY CARD ANIMACION SCROLL END /////////////////////////


//////////////// THEAD STICKY START /////////////////////////
const MIN_VISIBLE_ROWS = 4;

function checkTableSticky() {
    document.querySelectorAll('.js-thead-sticky').forEach((table) => {
        const thead = table.querySelector('thead');
        const tbody = table.querySelector('tbody');
        if (!thead || !tbody) return;

        // Solo filas visibles, para que funcione también al filtrar
        const rows = [...tbody.rows].filter((row) => row.getClientRects().length);
        if (!rows.length) return;

        const stickyTop = parseFloat(getComputedStyle(thead.querySelector('th')).top) || 0;
        const stopAt = stickyTop + thead.offsetHeight;

        // Si hay poco contenido (cabe en pantalla o no supera las filas mínimas), no hace falta sticky
        const fitsViewport = tbody.offsetHeight <= window.innerHeight - stopAt;
        const noSticky = fitsViewport || rows.length <= MIN_VISIBLE_ROWS;

        table.classList.toggle('no-sticky', noSticky);
        if (noSticky) {
            table.classList.remove('stop-sticky');
            return;
        }

        const limitRow = rows[Math.max(rows.length - MIN_VISIBLE_ROWS, 0)];

        table.classList.toggle('stop-sticky', limitRow.getBoundingClientRect().top <= stopAt);
    });
}

document.addEventListener('DOMContentLoaded', function () {
    const tables = document.querySelectorAll('.js-thead-sticky');
    if (!tables.length) return;

    // Recalcula si la tabla cambia de altura (p. ej. al filtrar filas)
    const tableResizeObserver = new ResizeObserver(checkTableSticky);
    tables.forEach((table) => tableResizeObserver.observe(table));

    document.addEventListener('scroll', checkTableSticky, { passive: true });
    window.addEventListener('resize', checkTableSticky);
    window.addEventListener('load', checkTableSticky);
    checkTableSticky();
});
//////////////// THEAD STICKY END /////////////////////////

//////////////// FIXED BTNS START /////////////////////////
document.addEventListener('DOMContentLoaded', function () {
    const fixedBtns = document.querySelector('.c-fixed-btns');
    if (!fixedBtns) return;

    const btnShow = fixedBtns.querySelector('.btn-show');
    if (!btnShow) return;

    btnShow.setAttribute('aria-expanded', 'false');
    btnShow.addEventListener('click', () => {
        const isOpen = fixedBtns.classList.toggle('show');
        btnShow.setAttribute('aria-expanded', isOpen);
    });
});
//////////////// FIXED BTNS END /////////////////////////

//////////////// HEAD ANCHORS STICKY START /////////////////////////
// .is-stuck: la barra está pegada arriba (necesita top: -1px en el css)
// .is-scroll-down: se está bajando, el css la sube --hide-offset para dejar solo las pestañas
document.addEventListener('DOMContentLoaded', function () {
    const headAnchors = document.querySelector('.c-head-anchors');
    if (!headAnchors) return;

    const title = headAnchors.querySelector('.h1');
    const minDelta = 5; // ignora movimientos pequeños del trackpad
    let lastY = window.scrollY;

    // Pegada = su top ya está en -1px (sticky top: -1px). No depende de que se vea entera en horizontal
    const updateStuck = () => headAnchors.classList.toggle('is-stuck', headAnchors.getBoundingClientRect().top < 0);
    updateStuck();

    // Altura a esconder (padding superior + título + su margen) y altura total para el scroll-margin de las secciones
    // En sticky la barra encoge: se compensa con margin-bottom para que el contenido de debajo no salte
    let fullHeight = headAnchors.offsetHeight;
    const setSizes = () => {
        if (title) {
            const hideOffset = title.offsetTop + title.offsetHeight + parseFloat(getComputedStyle(title).marginBottom) +6;
            headAnchors.style.setProperty('--hide-offset', hideOffset + 'px');
        }
        if (headAnchors.classList.contains('is-stuck')) {
            headAnchors.style.marginBottom = Math.max(0, fullHeight - headAnchors.offsetHeight) + 'px';
        } else {
            headAnchors.style.marginBottom = '';
            fullHeight = headAnchors.offsetHeight;
            document.documentElement.style.setProperty('--head-anchors-height', fullHeight + 'px');
        }
    };
    new ResizeObserver(setSizes).observe(headAnchors);

    window.addEventListener('scroll', () => {
        updateStuck();
        const y = window.scrollY;
        if (Math.abs(y - lastY) < minDelta) return;
        headAnchors.classList.toggle('is-scroll-down', y > lastY);
        lastY = y;
    }, { passive: true });

    // Enlace activo (sustituye al ScrollSpy de Bootstrap, que perdía el .active al redimensionar)
    // Activa la última sección cuyo top ya ha pasado la línea de corte
    // (= scroll-margin-top de las secciones + scroll-padding-top del html, que el navegador suma al ir al ancla)
    const links = [...headAnchors.querySelectorAll('.nav-link[href^="#"]')];
    const sections = links.map(link => document.querySelector(link.getAttribute('href')));
    const updateActive = () => {
        const scrollPadding = parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 0;
        const cut = fullHeight + scrollPadding + 2; // +2 de tolerancia por subpíxeles al llegar con un click
        const atBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2;
        let index = 0;
        sections.forEach((section, i) => {
            if (section && section.getBoundingClientRect().top <= cut) index = i;
        });
        if (atBottom) index = sections.length - 1; // la última sección puede no llegar a la línea
        links.forEach((link, i) => link.classList.toggle('active', i === index));
    };
    updateActive();
    window.addEventListener('scroll', updateActive, { passive: true });
    window.addEventListener('resize', updateActive);
});
//////////////// HEAD ANCHORS STICKY END /////////////////////////

//////////////// ILLNESSGEN SCROLL UP START /////////////////////////
// .is-scroll-up: se está subiendo
document.addEventListener('DOMContentLoaded', function () {
    const tables = document.querySelectorAll('.c-illnessgen table');
    if (!tables.length) return;

    const minDelta = 5; // ignora movimientos pequeños del trackpad
    let lastY = window.scrollY;

    window.addEventListener('scroll', () => {
        const y = window.scrollY;
        if (Math.abs(y - lastY) < minDelta) return;
        tables.forEach((table) => table.classList.toggle('is-scroll-up', y < lastY));
        lastY = y;
    }, { passive: true });
});
//////////////// ILLNESSGEN SCROLL UP END /////////////////////////

//////////////// DRAG SCROLL START /////////////////////////
// Arrastre horizontal con ratón e inercia al soltar. En táctil se deja el scroll nativo
document.addEventListener('DOMContentLoaded', function () {
    const friction = 0.95; // por frame a 60fps: más cerca de 1 = desliza más tras soltar
    const minVelocity = 0.02; // px/ms por debajo de la cual se para

    document.querySelectorAll('.js-drag-scroll').forEach((el) => {
        let isDown = false;
        let moved = false;
        let startX = 0;
        let startScroll = 0;
        let lastX = 0;
        let lastT = 0;
        let velocity = 0;
        let rafId = null;

        const stopMomentum = () => {
            cancelAnimationFrame(rafId);
            rafId = null;
        };

        const momentum = () => {
            let prevT = performance.now();
            const step = (t) => {
                const dt = t - prevT;
                prevT = t;
                const before = el.scrollLeft;
                el.scrollLeft -= velocity * dt;
                velocity *= Math.pow(friction, dt / 16.67);
                // Se para al perder velocidad o al llegar a un extremo
                if (Math.abs(velocity) < minVelocity || el.scrollLeft === before) return stopMomentum();
                rafId = requestAnimationFrame(step);
            };
            rafId = requestAnimationFrame(step);
        };

        el.addEventListener('pointerdown', (e) => {
            if (e.pointerType !== 'mouse' || e.button !== 0) return;
            stopMomentum();
            isDown = true;
            moved = false;
            startX = lastX = e.clientX;
            startScroll = el.scrollLeft;
            lastT = performance.now();
            velocity = 0;
        });

        el.addEventListener('pointermove', (e) => {
            if (!isDown) return;
            const dx = e.clientX - startX;
            // Hasta superar el umbral no se considera arrastre, para no romper los clics
            if (!moved && Math.abs(dx) < 5) return;
            if (!moved) {
                moved = true;
                el.classList.add('is-dragging');
                el.setPointerCapture(e.pointerId);
            }
            el.scrollLeft = startScroll - dx;

            const now = performance.now();
            const dt = now - lastT;
            if (dt > 0) velocity = 0.8 * ((e.clientX - lastX) / dt) + 0.2 * velocity;
            lastX = e.clientX;
            lastT = now;
        });

        const release = () => {
            if (!isDown) return;
            isDown = false;
            el.classList.remove('is-dragging');
            // Si se ha quedado quieto antes de soltar, no hay inercia
            if (moved && performance.now() - lastT < 80) momentum();
        };
        el.addEventListener('pointerup', release);
        el.addEventListener('pointercancel', release);

        // Rueda o trackpad cortan la inercia
        el.addEventListener('wheel', stopMomentum, { passive: true });

        // Si se ha arrastrado, el clic al soltar no abre el modal
        el.addEventListener('click', (e) => {
            if (!moved) return;
            e.preventDefault();
            e.stopPropagation();
            moved = false;
        }, true);
    });
});
//////////////// DRAG SCROLL END /////////////////////////

//////////////// BREEDS PERCENT SWIPER START /////////////////////////
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.js-bredspercent').forEach((el) => {
        const rem = parseFloat(getComputedStyle(document.documentElement).fontSize);
        // Flechas y bullets opcionales: solo se activan si existe el marcado dentro del swiper
        const nextEl = el.querySelector('.c-bredspercent_arrow.next');
        const prevEl = el.querySelector('.c-bredspercent_arrow.prev');
        const paginationEl = el.querySelector('.c-bredspercent_pagination');
        new Swiper(el, {
            navigation: nextEl && prevEl ? {
                nextEl,
                prevEl,
            } : false,
            pagination: paginationEl ? {
                el: paginationEl,
                enabled: true, // explícito: Swiper no lo trae por defecto y sin él el breakpoint nunca la reactiva
                clickable: true,
                dynamicBullets: true,
                dynamicMainBullets: 1, // uno grande en el centro + los de los lados en pequeño
            } : false,
            // En escritorio (sm+) se desactiva la paginación desde Swiper (no solo por CSS):
            // así al volver a móvil se re-renderiza y mide bien los bullets
            breakpoints: paginationEl ? {
                768: { pagination: { enabled: false } }, // breakpoint sm
            } : undefined,
            slidesPerView: 'auto',
            grabCursor: true,
            freeMode: {
                enabled: true,
                momentum: true,
            },
            mousewheel: {
                forceToAxis: true,
            },
        });
    });
});
//////////////// BREEDS PERCENT SWIPER END /////////////////////////

//////////////// CHART DONUT START /////////////////////////
// Uso: <figure class="c-chart js-chart"> con un <circle class="c-chart_segment" data-value="45"> por valor (ver _c-chart.scss)
// Los segmentos se dibujan seguidos desde arriba en sentido horario; si suman < 100 el resto queda vacío.
document.addEventListener('DOMContentLoaded', function () {
    const charts = document.querySelectorAll('.js-chart');
    if (!charts.length) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const fullCircleDuration = 1.6; // segundos en recorrer el 100%

    const buildTimeline = (chart) => {
        const tl = gsap.timeline({ paused: true });
        // Hueco entre segmentos en proporción al grosor (--chart-segment-gap en _c-chart.scss)
        const segmentGap = parseFloat(getComputedStyle(chart).getPropertyValue('--chart-segment-gap'));
        let start = 0;

        chart.querySelectorAll('.c-chart_segment').forEach((seg) => {
            const value = Math.min(parseFloat(seg.dataset.value) || 0, 100 - start);
            if (value <= 0) return;

            const style = getComputedStyle(seg);
            const circumference = 2 * Math.PI * parseFloat(style.r); // el radio viene del SCSS
            // Las puntas redondeadas sobresalen medio grosor por lado: se recortan y se deja hueco entre segmentos.
            // Si un solo valor ocupa el 100% no hay hueco que dejar.
            const trim = value >= 100 ? 0 : parseFloat(style.strokeWidth) * (1 + (isNaN(segmentGap) ? .65 : segmentGap));
            const length = Math.max(value / 100 * circumference - trim, 0.01);

            seg.setAttribute('stroke-dashoffset', -(start / 100 * circumference + trim / 2));
            tl.set(seg, { opacity: 1 })
              .fromTo(seg,
                  { attr: { 'stroke-dasharray': '0 ' + circumference } },
                  { attr: { 'stroke-dasharray': length + ' ' + circumference }, duration: fullCircleDuration * value / 100, ease: 'none' });

            start += value;
        });
        return tl;
    };

    charts.forEach((chart) => {
        const tl = buildTimeline(chart);
        const play = () => gsap.fromTo(tl, { progress: 0 }, { progress: 1, duration: tl.duration(), ease: 'power2.inOut' });

        if (reduceMotion) {
            tl.progress(1);
            return;
        }
        // Dentro de un modal se anima cada vez que se abre (oculto, ScrollTrigger no puede calcular su posición)
        const modal = chart.closest('.modal');
        if (modal) {
            modal.addEventListener('shown.bs.modal', play);
            return;
        }
        ScrollTrigger.create({ trigger: chart, start: 'top 80%', once: true, onEnter: play });
    });
});
//////////////// CHART DONUT END /////////////////////////

//////////////// INPUT RANGE START /////////////////////////
// Uso: <div class="o-range js-range"> con un input range y botones data-range-step="-10" / "10" (cuántos steps mueve)
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.js-range').forEach((wrap) => {
        const range = wrap.querySelector('input[type="range"]');
        if (!range) return;

        // Chrome/Safari no pintan la parte rellena: se pasa el % al CSS
        const updateProgress = () => {
            const min = parseFloat(range.min) || 0;
            const max = parseFloat(range.max) || 100;
            range.style.setProperty('--progress', (range.value - min) / (max - min) * 100 + '%');
        };

        wrap.querySelectorAll('[data-range-step]').forEach((btn) => {
            btn.addEventListener('click', () => {
                const steps = parseInt(btn.dataset.rangeStep, 10) || 1;
                steps > 0 ? range.stepUp(steps) : range.stepDown(-steps);
                range.dispatchEvent(new Event('input', { bubbles: true }));
            });
        });

        range.addEventListener('input', updateProgress);
        updateProgress();
    });
});
//////////////// INPUT RANGE END /////////////////////////

//////////////// CROP FOTO START /////////////////////////
// Recorte cuadrado: se arrastra la foto para encuadrarla y el range (.js-range) del mismo contenedor hace zoom.
// Uso: .js-crop con .js-crop-area > img.js-crop-img, input file .js-crop-file y botón .js-crop-save
//   data-crop-output: selector de las imágenes que se actualizan al guardar
//   data-crop-url (opcional): endpoint al que se sube el recorte por POST (campo "foto")
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.js-crop').forEach((crop) => {
        const area = crop.querySelector('.js-crop-area');
        const img = crop.querySelector('.js-crop-img');
        const file = crop.querySelector('.js-crop-file');
        const range = crop.querySelector('.js-range input[type="range"]');
        const save = crop.querySelector('.js-crop-save');
        const modal = crop.closest('.modal');
        if (!area || !img) return;

        const maxZoom = 3;
        const outputSize = 800; // lado en px de la imagen final
        let savedSrc = img.src;
        let fileUrl = null;
        let zoom = 1;
        let cx = 0, cy = 0; // centro del encuadre, en px de la imagen original
        let x = 0, y = 0, scale = 1, size = 0; // último render
        let drag = null;

        const render = () => {
            size = area.clientWidth;
            if (!size || !img.naturalWidth) return; // modal cerrado o imagen sin cargar
            scale = size / Math.min(img.naturalWidth, img.naturalHeight) * zoom;
            // La foto siempre cubre el círculo: el centro no puede acercarse al borde más de medio encuadre
            const half = size / 2 / scale;
            cx = Math.min(Math.max(cx, half), img.naturalWidth - half);
            cy = Math.min(Math.max(cy, half), img.naturalHeight - half);
            x = size / 2 - cx * scale;
            y = size / 2 - cy * scale;
            img.style.width = img.naturalWidth + 'px';
            img.style.transform = `translate(${x}px, ${y}px) scale(${scale})`;
        };

        const reset = () => {
            cx = img.naturalWidth / 2;
            cy = img.naturalHeight / 2;
            if (range) {
                range.value = range.min || 0;
                range.dispatchEvent(new Event('input', { bubbles: true })); // pone zoom a 1 y renderiza
            } else {
                zoom = 1;
                render();
            }
        };

        img.addEventListener('load', reset);
        if (img.complete) reset();

        if (range) {
            range.addEventListener('input', () => {
                const min = parseFloat(range.min) || 0;
                const max = parseFloat(range.max) || 100;
                zoom = 1 + (range.value - min) / (max - min) * (maxZoom - 1);
                render();
            });
        }

        // Arrastre (ratón y táctil)
        area.addEventListener('pointerdown', (e) => {
            drag = { x: e.clientX, y: e.clientY, cx, cy };
            area.setPointerCapture(e.pointerId);
            area.classList.add('is-dragging');
        });
        area.addEventListener('pointermove', (e) => {
            if (!drag) return;
            cx = drag.cx - (e.clientX - drag.x) / scale;
            cy = drag.cy - (e.clientY - drag.y) / scale;
            render();
        });
        const endDrag = () => {
            drag = null;
            area.classList.remove('is-dragging');
        };
        area.addEventListener('pointerup', endDrag);
        area.addEventListener('pointercancel', endDrag);

        // Teclado: las flechas mueven la foto 10px
        const moves = { ArrowLeft: [-1, 0], ArrowRight: [1, 0], ArrowUp: [0, -1], ArrowDown: [0, 1] };
        area.addEventListener('keydown', (e) => {
            const move = moves[e.key];
            if (!move) return;
            e.preventDefault();
            cx -= move[0] * 10 / scale;
            cy -= move[1] * 10 / scale;
            render();
        });

        if (file) {
            file.addEventListener('change', () => {
                const chosen = file.files[0];
                if (!chosen || !chosen.type.startsWith('image/')) return;
                if (fileUrl) URL.revokeObjectURL(fileUrl);
                fileUrl = URL.createObjectURL(chosen);
                img.src = fileUrl; // al cargar hace reset
            });
        }

        if (save) {
            save.addEventListener('click', () => {
                if (!size) return;
                // Se dibuja en un canvas cuadrado justo la zona visible dentro del círculo
                const canvas = document.createElement('canvas');
                canvas.width = canvas.height = outputSize;
                const side = size / scale;
                canvas.getContext('2d').drawImage(img, -x / scale, -y / scale, side, side, 0, 0, outputSize, outputSize);
                canvas.toBlob((blob) => {
                    if (!blob) return;
                    const url = URL.createObjectURL(blob);
                    if (crop.dataset.cropOutput) {
                        document.querySelectorAll(crop.dataset.cropOutput).forEach((el) => { el.src = url; });
                    }
                    if (crop.dataset.cropUrl) {
                        const data = new FormData();
                        data.append('foto', blob, 'foto.jpg');
                        // Token CSRF de Yii si el layout tiene las meta (Html::csrfMetaTags)
                        const csrfParam = document.querySelector('meta[name="csrf-param"]');
                        const csrfToken = document.querySelector('meta[name="csrf-token"]');
                        if (csrfParam && csrfToken) data.append(csrfParam.content, csrfToken.content);
                        fetch(crop.dataset.cropUrl, { method: 'POST', body: data })
                            .catch((err) => console.error('Error subiendo la foto', err));
                    }
                    savedSrc = url;
                    img.src = url;
                    if (modal) bootstrap.Modal.getOrCreateInstance(modal).hide();
                }, 'image/jpeg', 0.9);
            });
        }

        if (modal) {
            // Cerrado el tamaño es 0: se recalcula al abrir. Al cerrar sin guardar se vuelve a la foto guardada
            modal.addEventListener('shown.bs.modal', render);
            modal.addEventListener('hidden.bs.modal', () => {
                if (file) file.value = '';
                if (img.src !== savedSrc) img.src = savedSrc;
                else reset();
            });
        }
        window.addEventListener('resize', render);
    });
});
//////////////// CROP FOTO END /////////////////////////

